import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-51827240"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "alerts-chart-container"
};
const _hoisted_2 = {
  class: "charts-grid"
};
const _hoisted_3 = {
  class: "charts-columns"
};
const _hoisted_4 = {
  class: "charts-rows"
};
const _hoisted_5 = {
  class: "chart-title"
};
const _hoisted_6 = {
  class: "charts-legend"
};
const _hoisted_7 = {
  class: "charts-title-text"
};
const _hoisted_8 = {
  class: "charts-legend"
};
const _hoisted_9 = ["id"];
const _hoisted_10 = {
  class: "charts-bar"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "charts-bar-value"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "charts-bar-value"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "charts-bar-value"
};
const _hoisted_17 = {
  class: "chart-bottom"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "charts-legend"
}, null, -1));
const _hoisted_19 = {
  class: "charts-bottom-legend"
};
const _hoisted_20 = {
  class: "charts-bottom-values"
};
const _hoisted_21 = {
  class: "charts-bottom-item-text"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "charts-bottom-text"
}, " Number of alerts ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(6).fill(1), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "charts-columns-item"
    });
  }), 128))]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array($props.items.length).fill(1), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "charts-rows-item"
    });
  }), 128))])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString($options.title), 1)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item.id,
      class: _normalizeClass(['charts-row', {
        selected: $props.selectedRowId == item.id
      }])
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("p", {
      class: "charts-legend-text",
      id: item.title
    }, _toDisplayString(item.title), 9, _hoisted_9), _createVNode(_component_app_popover, {
      target: item.title,
      placement: "top"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
      _: 2
    }, 1032, ["target"])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
      class: _normalizeClass(['charts-bar-box', 'charts-urgent', {
        active: item.id == $props.selectedRowId && $props.selectedLevel == '1_URGENCY'
      }, {
        hidden: $options.percents(item.alerts['1_URGENCY']) == 0
      }, {
        small: $options.percents(item.alerts['1_URGENCY']) <= 6
      }]),
      style: _normalizeStyle({
        width: $options.percents(item.alerts['1_URGENCY']) + '%'
      }),
      onClick: $event => $options.onToggleSelect(item.id, '1_URGENCY')
    }, [_createElementVNode("p", _hoisted_12, _toDisplayString(item.alerts['1_URGENCY']), 1)], 14, _hoisted_11), _createElementVNode("div", {
      class: _normalizeClass(['charts-bar-box', 'charts-alert', {
        active: item.id == $props.selectedRowId && $props.selectedLevel == '2_ALERT'
      }, {
        hidden: $options.percents(item.alerts['2_ALERT']) == 0
      }, {
        small: $options.percents(item.alerts['2_ALERT']) <= 6
      }]),
      style: _normalizeStyle({
        width: $options.percents(item.alerts['2_ALERT']) + '%'
      }),
      onClick: $event => $options.onToggleSelect(item.id, '2_ALERT')
    }, [_createElementVNode("p", _hoisted_14, _toDisplayString(item.alerts['2_ALERT']), 1)], 14, _hoisted_13), _createElementVNode("div", {
      class: _normalizeClass(['charts-bar-box', 'charts-warning', {
        active: item.id == $props.selectedRowId && $props.selectedLevel == '3_WARNING'
      }, {
        hidden: $options.percents(item.alerts['3_WARNING']) == 0
      }, {
        small: $options.percents(item.alerts['3_WARNING']) <= 6
      }]),
      style: _normalizeStyle({
        width: $options.percents(item.alerts['3_WARNING']) + '%'
      }),
      onClick: $event => $options.onToggleSelect(item.id, '3_WARNING')
    }, [_createElementVNode("p", _hoisted_16, _toDisplayString(item.alerts['3_WARNING']), 1)], 14, _hoisted_15)])], 2);
  }), 128)), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(6).fill(1), (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "charts-bottom-item"
    }, [_createElementVNode("div", _hoisted_21, _toDisplayString($options.value(index)), 1)]);
  }), 128))]), _hoisted_22])])]);
}